import React, { useMemo } from "react";

import { menu } from "@src/Menu";
import AppMenu from "@auto/widgets/DesktopMenu";

export function AppNavigator({
  gui,
  session
}) {
  const sections =
    useMemo(
      () => menu(session),
      [session]
    );

  return (
    <AppMenu
      gui={gui}
      session={session}
      sections={sections}
    />
  );
}